/**
 * Öffentliche URLs für Widget-Embed und Chat-Links (Admin-Frontend-Host).
 * Setze REACT_APP_PUBLIC_WIDGET_URL oder REACT_APP_FRONTEND_URL in der Build-Umgebung.
 */
export function getPublicWidgetBaseUrl() {
  const env = process.env.REACT_APP_PUBLIC_WIDGET_URL || process.env.REACT_APP_FRONTEND_URL;
  if (env && String(env).trim()) {
    return String(env).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

export function widgetUrlForBot(botId) {
  const base = getPublicWidgetBaseUrl();
  const path = `/api/bot/${botId}/widget`;
  if (!base) return path;
  return `${base}${path}`;
}
